import React from 'react';
import { ItemScheme } from '../../../../Components/Form/MagicFormItem';
import { WizardItem } from '../../Interfaces/Wizard.interface';
import { WizardItemType } from '../../Enums/WizardItemType.enum';
import { WizardItemSubType } from '../../Enums/WizardItemSubType.enum';
import { WizardActionDestination } from '../../Enums/WizardActionDestination.enum';
import { resolveWizardAction } from '../../Services/wizard.service';
import LinkButton from '../../../../Components/Button/LinkButton';
import Button from '../../../../Components/Button/Button';
import { Theme } from '../../../../Enums/Theme.enum';

type WizardButtonSettings = Extract<
	WizardItem,
	{ type: WizardItemType.BUTTON }
>['settings'] & { submitData?: object };

interface Props {
	itemScheme: ItemScheme;
	onSubmit: (values: unknown) => void;
}

const WizardButton: React.FC<Props> = ({ itemScheme, onSubmit }) => {
	const settings: WizardButtonSettings = itemScheme?.settings ?? {};
	const action = settings.action;
	const title = itemScheme?.title || itemScheme?.label || '';
	const theme = (settings.theme as Theme) || Theme.BLUE;
	const browserUrl =
		action?.destination === WizardActionDestination.BROWSER
			? action.url
			: undefined;

	const handleClick = () => {
		if (action) {
			resolveWizardAction(action);
			return;
		}
		onSubmit(settings.submitData ?? {});
	};

	if (itemScheme?.subType === WizardItemSubType.TEXT) {
		return (
			<LinkButton
				title={title}
				theme={theme}
				href={browserUrl}
				onClick={browserUrl ? undefined : handleClick}
			/>
		);
	}

	if (browserUrl) {
		return (
			<LinkButton
				title={title}
				theme={theme}
				href={browserUrl}
				displayAsButton
			/>
		);
	}

	return (
		<Button
			onClick={handleClick}
			title={title}
			badge={settings.badge?.text}
			theme={theme}
		/>
	);
};

export default WizardButton;
